import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import _ from 'lodash';
import { Observable } from 'rxjs';
import {
  ModalOpenerService,
  UserService,
  EnterpriseSearchService,
  ServiceType
} from '@sabstravtech/obtservices/angular';
import { TranslateService } from '@ngx-translate/core';
import { FerryEnterpriseSearchInterface, FerryTempParams } from '@sabstravtech/obtservices/base';
import { Router } from '@angular/router';

import { BaseResultsComponent } from '../../../core/components/base_components/base-results.component';
import { LightningModalTypes } from '../../../core/classes/modal-types.enum';
import { DeviceDetector } from '../../../core/services/device-detector.service';
import { ThemeService } from '../../../core/services/theme.service';

@Component({
  selector: 'app-ferry',
  templateUrl: './ferry.component.html',
  styleUrls: ['./ferry.component.scss'],
  standalone: false
})
export class FerryComponent extends BaseResultsComponent implements OnInit {
  searchType: ServiceType = ServiceType.Ferry;
  searchResults: any = {
    outbound: [],
    inbound: []
  };
  $margin: Observable<number> = new Observable();
  showClasses: any;
  public searchParams: FerryEnterpriseSearchInterface;
  public search: FerryTempParams;

  constructor(
    public searchService: EnterpriseSearchService,
    public deviceDetector: DeviceDetector,
    public modalService: ModalOpenerService,
    titleService: Title,
    translateService: TranslateService,
    router: Router,
    themeService: ThemeService,
    userService: UserService
  ) {
    super(titleService, translateService, themeService, searchService, userService, router);
    this.searchParams = searchService.searches[ServiceType.Ferry];
  }

  ngOnInit(): void {
    this.setResultsTitle('Ferry results');
    this.search = this.searchService.searches[ServiceType.Ferry].originalUserSearch;
  }

  openFareRules(): void {
    this.modalService.open(
      LightningModalTypes.ModalFareRulesComponent,
      {
        windowClass: 'fare-rules-modal',
        centered: true
      },
      {}
    );
  }

  openFareRulesAndFocus(): void {
    this.openFareRules();
    document.getElementById('standardHeader').focus();
  }

  skipToResultContent(): boolean {
    return super.skipToResultContent('ferry');
  }

  /**
   * Do another search
   */
  reSearch(): void {
    this.performReSearch(ServiceType.Ferry, () => {
      this.search = this.searchService.searches[ServiceType.Ferry].originalUserSearch;
    });
  }
}
